export const getChannelData = (audioBuffer: AudioBuffer): Float32Array[] => {
    const channels: Float32Array[] = [];
    for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
        channels.push(audioBuffer.getChannelData(i));
    }
    return channels;
};
